import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

const AppUrlListener = () => {
	const history = useHistory();
	const location = useLocation();
	
	const handleIncomingUrl = (url) => {
		try {
			console.log('Received URL:', url);
			
			const platform = Capacitor.getPlatform();
			const parsed = new URL(url);
			let path = '';
			
			if (platform === 'ios') {
				const incomingOrigin = `${parsed.protocol}//${parsed.host}`;
				path = url.replace(incomingOrigin, '');
			} else if (platform === 'android') {
				if (url.startsWith('https://')) {
					// Android App Link (https)
					const incomingOrigin = `${parsed.protocol}//${parsed.host}`;
					path = url.replace(incomingOrigin, '');
				} else {
					// Android custom scheme (myapp://app/...)
					path = (parsed.pathname + parsed.search).replace(/^\/app/, '');
				}
			} else {
				const appOrigin = `${window.location.protocol}//${window.location.host}`;
				path = url.replace(appOrigin, '');
			}
			
			path = decodeURIComponent(path || '').trim();
			console.log('Resolved path:', path);
			
			// Always redirect root to /login with parameter
			if (!path || path === '/') {
				history.push(`/login${parsed.search}`);
				sessionStorage.setItem('cond', parsed.searchParams.get('cond') || '');
				return;
			}
			
			// Always store cond if it exists in /login
			if (path.startsWith('/login')) {
				sessionStorage.setItem('cond', parsed.searchParams.get('cond') || '');
			}
			
			if (window.location.pathname + window.location.search === path) {
				window.location.reload();
			} else {
				history.push(path);
			}
		} catch (err) {
			console.error('URL parse error', err);
			history.push('/login');
		}
	};
	
	useEffect(() => {
		// cold start
		const storedUrl = sessionStorage.getItem('initialUrl');
		if (storedUrl) {
			sessionStorage.removeItem('initialUrl');
			const delay = Capacitor.isNativePlatform() ? 1000 : 0;
			setTimeout(() => handleIncomingUrl(storedUrl), delay);
		}
		
		// warm start
		App.addListener('appUrlOpen', ({ url }) => {
			console.log('[appUrlOpen fired]', url);
			handleIncomingUrl(url);
		});
		
		return () => App.removeAllListeners();
	}, []);
	
	
	return null;
};

export default AppUrlListener;